import React, { useState, useEffect } from 'react';
import { goBack } from 'connected-react-router';
import { useSelector, useDispatch } from 'react-redux';
import { PageHeader, Divider, Typography } from 'antd';
import styled from 'styled-components';
import { setSidebarVisibility } from 'reducers/ui';
import Table from './Table';
const { Title } = Typography;

const CallingSheetListComponent = (props) => {
  const storedTotalRows = useSelector((state) => {
    return state.callingsheet.totalRows;
  });
  const [totalRows, setTotalRows] = useState(storedTotalRows || null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSidebarVisibility(false));
  }, [dispatch]);

  return (
    <Container>
      <StyledPageHeader
        ghost={false}
        onBack={() => dispatch(goBack())}
        title='Calling Sheets List'
        subTitle=''
        extra={
          totalRows != null && <Title level={5}>{`Total ${totalRows}`}</Title>
        }
      />
      <Divider style={{ margin: 0 }} />
      <Content>
        <Table totalRows={totalRows} setTotalRows={setTotalRows} />
      </Content>
    </Container>
  );
};

const StyledPageHeader = styled(PageHeader)`
  padding: 0px 10px;
`;

const Container = styled.div`
  height: calc(100%);
  padding: 10px;
`;

const Content = styled.div`
  background: white;
  height: calc(100% - 42px);
  overflow: auto;
`;

export default CallingSheetListComponent;
